import C from 'actionTypes'

const defaultState = {
  windowMode: 'screen-xxs',
  isMobile: true,
  isTablet: false,
  isDesktop: false,
  windowHeight: 0,
  siteNavOpen: false,
  error: null,
}

const windowModes = {
  0: 'screen-xxs',
  480: 'screen-xs',
  768: 'screen-sm',
  1024: 'screen-md',
  1200: 'screen-lg',
  1440: 'screen-xl',
}

const mobileNavModes = ['screen-xxs', 'screen-xs']
const tabletNavModes = ['screen-sm']
const desktopNavModes = ['screen-md', 'screen-lg', 'screen-xl']

const system = (state = defaultState, action) => {
  switch (action.type) {
    case C.SET_WINDOW_MODE: {
      const {
        dimensions,
      } = action

      // eslint-disable-next-line prefer-destructuring
      let windowMode = windowModes[0] // Default to smallest size
      for (const width in windowModes) {
        if (dimensions.w >= width) {
          windowMode = windowModes[width]
        }
      }

      return {
        ...state,
        windowMode,
        isMobile: mobileNavModes.indexOf(windowMode) > -1,
        isTablet: tabletNavModes.indexOf(windowMode) > -1,
        isDesktop: desktopNavModes.indexOf(windowMode) > -1,
        windowHeight: dimensions.h,
      }
    }

    case C.OPEN_NAV: {
      return {
        ...state,
        siteNavOpen: true
      }
    }

    case C.CLOSE_NAV: {
      return {
        ...state,
        siteNavOpen: false
      }
    }

    case C.SET_ERROR: {
      const { error } = action
      return {
        ...state,
        error,
      }
    }

    case C.CLEAR_ERROR: {
      return {
        ...state,
        error: null
      }
    }

    case C.SET_APP_TYPE: {
      const { appType } = action
      return {
        ...state,
        appType
      }
    }

    default:
      return state
  }
}

export default system



// WEBPACK FOOTER //
// ./src/reducers/system.js